
import { Injectable } from '@angular/core';
import { apiBase, LocalStorage } from "../../enums";
import { LocalStorageService } from './local-storage.service';

@Injectable({
    providedIn: 'root'
})
export class ApiService {

    code: any = [
        { key: 100, value: "Continue" },
        { key: 101, value: "101" },

        { key: 200, value: "OK" },
        { key: 201, value: "Created" },
        { key: 202, value: "Accepted" },
        { key: 203, value: "Non-Authoritative Information" },
        { key: 204, value: "No Content" },
        { key: 205, value: "Reset Content" },
        { key: 206, value: "Partial Content" },

        { key: 300, value: "Multiple Choices" },
        { key: 301, value: "Moved Permanently" },
        { key: 302, value: "Found" },
        { key: 303, value: "See Other" },
        { key: 304, value: "Not Modified" },
        { key: 305, value: "Use Proxy" },
        { key: 306, value: "(Unused)" },
        { key: 307, value: "Temporary Redirect" },

        { key: 400, value: "Bad Request" },
        { key: 401, value: "Unauthorized" },
        { key: 402, value: "Payment Required" },
        { key: 403, value: "Forbidden" },
        { key: 404, value: "Not Found" },
        { key: 405, value: "Method Not Allowed" },
        { key: 406, value: "Not Acceptable" },
        { key: 407, value: "Proxy Authentication Required" },
        { key: 408, value: "Request Timeout" },
        { key: 409, value: "Conflict" },
        { key: 410, value: "Gone" },
        { key: 411, value: "Length Required" },
        { key: 412, value: "Precondition Failed" },
        { key: 413, value: "Request Entity Too Large" },
        { key: 414, value: "Request-URI Too Long" },
        { key: 415, value: "Unsupported Media Type" },
        { key: 416, value: "Requested Range Not Satisfiable" },
        { key: 417, value: "Expectation Failed" },

        { key: 500, value: "Internal Server Error" },
        { key: 501, value: "Not Implemented" },
        { key: 502, value: "Bad Gateway" },
        { key: 503, value: "Service Unavailable" },
        { key: 504, value: "Gateway Timeout" },
        { key: 505, value: "HTTP Version Not Supported" }
    ];

    basicAuthUrls = [
        apiBase.login
    ];

    constructor(
        private localStorageService: LocalStorageService
    ) { }

    getToken = (url: string, headers: any) => {
        try {
            const accessToken = this.localStorageService.getData(LocalStorage.accessToken);
            // const localAccessToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJ0ZXN0QGJodWxrYXNhZ2Fyc2Nob29sLmNvbSIsImp0aSI6IjAwMmY2NzRlLTg3ZmEtNDhhNS1hNjRiLTFmYjI2OWZjNjVhYiIsImh0dHA6Ly9zY2hlbWFzLnhtbHNvYXAub3JnL3dzLzIwMDUvMDUvaWRlbnRpdHkvY2xhaW1zL25hbWUiOiJ0ZXN0QGJodWxrYXNhZ2Fyc2Nob29sLmNvbSIsImV4cCI6MTgwNjI2ODkxNCwiaXNzIjoiYmh1bGthc2FnYXJuZXQiLCJhdWQiOiJiaHVsa2FzYWdhcm5ldFVzZXJzIn0.ToMkdQ0mLmXFBPEg34_9TxQ4WGLHADGb9o2g_39ZCeI';

            const isBasicUrl = this.basicAuthUrls.indexOf(url) !== -1;
            if (isBasicUrl) {
                return headers;
            } else {
                return {
                    ...headers,
                    // Authorization: "Bearer " + ((accessToken !== null && accessToken.length > 0) ? accessToken : localAccessToken)
                    Authorization: "Bearer " + accessToken
                };
            }
        } catch (error: any) {
            console.log(error);
            return headers;
        }
    };

    getCall = async (url: any) => {
        try {
            // let dbNameUrl = "";
            // const dbName = this.localStorageService.getData(LocalStorage.dbName);
            // if (dbName) {
            //     dbNameUrl = dbName;
            //     if (url.includes('dataBaseName')) {
            //         url = url.replace('dataBaseName', dbNameUrl);
            //     }
            // }
            // let garageCodeUrl = "";
            // const loginData = JSON.parse(this.localStorageService.getData(LocalStorage.loginData));
            // if (loginData?.garageCode) {
            //     garageCodeUrl = loginData.garageCode;
            //     if (url.includes('garageCode')) {
            //         url = url.replace('garageCode', garageCodeUrl);
            //     }
            // }

            const response = await fetch(encodeURI(apiBase.apiUrl + url), {
                method: 'GET',
                headers: this.getToken(url, {}),
            });

            return this.responseCall(response);
        } catch (error: any) {
            return {
                "status": 0,
                "message": error.message
            };
        }
    };

    postCall = async (url: any, data: any) => {
        try {
            // let dbNameUrl = "";
            // const dbName = this.localStorageService.getData(LocalStorage.dbName);
            // if (dbName) {
            //     dbNameUrl = dbName;
            //     if (url.includes('dataBaseName')) {
            //         url = url.replace('dataBaseName', dbNameUrl);
            //     }
            // }
            const response = await fetch(encodeURI(apiBase.apiUrl + url), {
                method: 'POST',
                headers: this.getToken(url, {
                    'Accept': 'application/json',
                    "Content-Type": "application/json"
                }),
                body: data
            });
            return this.responseCall(response);
        } catch (error: any) {
            return {
                "status": 0,
                "message": error.message
            };
        }
    };

    deleteCall = async (url: any, data: any) => {
        try {
            // let dbNameUrl = "";
            // const dbName = this.localStorageService.getData(LocalStorage.dbName);
            // if (dbName) {
            //     dbNameUrl = dbName;
            //     if (url.includes('dataBaseName')) {
            //         url = url.replace('dataBaseName', dbNameUrl);
            //     }
            // }
            const response = await fetch(encodeURI(apiBase.apiUrl + url), {
                method: 'DELETE',
                headers: this.getToken(url, {
                    'Accept': 'application/json',
                    "Content-Type": "application/json"
                }),
                body: data
            });
            return this.responseCall(response);
        } catch (error: any) {
            return {
                "status": 0,
                "message": error.message
            };
        }
    };


    patchCall = async (url: any) => {
        try {
            const response = await fetch(encodeURI(apiBase.apiUrl + url), {
                method: 'PATCH',
                headers: this.getToken(url, {
                    'Accept': 'application/json',
                    "Content-Type": "application/json"
                }),
                // body: data
            });
            return this.responseCall(response);
        } catch (error: any) {
            return {
                "status": 0,
                "message": error.message
            };
        }
    };

    putCall = async (url: any, data: any) => {
        try {
            let dbNameUrl = "";
            const dbName = this.localStorageService.getData(LocalStorage.dbName);
            if (dbName) {
                dbNameUrl = dbName;
                if (url.includes('dataBaseName')) {
                    url = url.replace('dataBaseName', dbNameUrl);
                }
            }
            const response = await fetch(encodeURI(apiBase.apiUrl + url), {
                method: 'PUT',
                headers: this.getToken(url, {
                    'Accept': 'application/json',
                    "Content-Type": "application/json"
                }),
                body: data
            });
            return this.responseCall(response);
        } catch (error: any) {
            return {
                "status": 0,
                "message": error.message
            };
        }
    };

    putCallFormData = async (url: any, data: any) => {
        try {
            let dbNameUrl = "";
            const dbName = this.localStorageService.getData(LocalStorage.dbName);
            if (dbName) {
                dbNameUrl = dbName;
                if (url.includes('dataBaseName')) {
                    url = url.replace('dataBaseName', dbNameUrl);
                }
            }
            const response = await fetch(encodeURI(apiBase.apiUrl + url), {
                method: 'PUT',
                headers: this.getToken(url, {
                    // 'Content-Type': 'multipart/form-data',
                }),
                body: data
            });
            return this.responseCall(response);
        } catch (error: any) {
            return {
                "status": 0,
                "message": error.message
            };
        }
    };

    postFormCall = async (url: any, data: any) => {
        try {
            let dbNameUrl = "";
            const dbName = this.localStorageService.getData(LocalStorage.dbName);
            if (dbName) {
                dbNameUrl = dbName;
                if (url.includes('dataBaseName')) {
                    url = url.replace('dataBaseName', dbNameUrl);
                }
            }
            const response = await fetch(encodeURI(apiBase.apiUrl + dbNameUrl + url), {
                method: 'POST',
                headers: this.getToken(url, {}),
                body: data
            });
            return this.responseCall(response);
        } catch (error: any) {
            return {
                "status": 0,
                "message": error.message
            };
        }
    };

    fileDownload = async (data: any) => {
        try {
            const response = await fetch(apiBase.imageApiUrl, {
                method: 'POST',
                headers: this.getToken(apiBase.imageApiUrl, {
                    'Accept': 'application/json',
                    'Content-Type': 'multipart/form-data;'
                }),
                body: data
            });
            return this.responseCall(response);
        } catch (error: any) {
            return {
                "status": 0,
                "message": error.message
            };
        }
    };

    signatureUpload = async (data: any) => {
        try {
            const response = await fetch(apiBase.imageApiUrl, {
                method: 'POST',
                headers: this.getToken(apiBase.imageApiUrl, {
                    'Accept': 'application/json',
                    'Content-Type': 'multipart/form-data;'
                }),
                body: data
            });
            return this.responseCall(response);
        } catch (error: any) {
            return {
                "status": 0,
                "message": error.message
            };
        }
    };

    responseCall = async (response: any) => {
        let message = "";
        this.code.every((element: any) => {
            if (element.key === response.status) {
                message = element.value;
                return false;
            }
            return true;
        });
        if (response.status === 200) {
            const responses = await response.text();
            return JSON.parse(responses);
        }
        else {
            return {
                "status": 0,
                "message": message
            };
        }
    };

    cancelCall = async () => {
        return {
            status: -1,
            message: "API call is in progress"
        };
    };

}